module.exports = __webpack_public_path__ + "img/imagen_web_cursos.8f04ad9b.jpg";